<div class="mb-4 mt-4" *ngIf="decisionInput$ | async as decisionInput">
  <div class="data-table">
    <div class="loading-shade" *ngIf="isLoadingResults">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>

    <div class="d-flex justify-content-between align-items-baseline">
      <mat-label class="font-weight-bold field-required">{{ title | translate }} </mat-label>
      <div>
        <button mat-icon-button *ngIf="enabledSummary" matTooltip="{{ 'forms.common.Add' | translate }}"
          (click)="showSummary(decisionInput)">
          <mat-icon>add</mat-icon>
        </button>
        <button mat-icon-button *ngIf="decisionInput.executeVisitType == finalReport && !decisionInput.viewOnly"
          matTooltip="{{ 'forms.common.Criteria.membersEntries' | translate }}"
          (click)="expandedFilter=!expandedFilter;">
          <mat-icon>filter_alt</mat-icon>
        </button>
      </div>
    </div>

    <mat-accordion>
      <mat-expansion-panel [expanded]="expandedFilter">
        <app-summary-filter *ngIf="expandedFilter" (onCloseFilter)="expandedFilter=!expandedFilter;"
          [filter]="filter"></app-summary-filter>
      </mat-expansion-panel>
    </mat-accordion>

    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="summary">
        <th mat-header-cell *matHeaderCellDef>
          <strong> {{ "forms.common.Criteria.summary" | translate }}</strong>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="content">{{ row?.summaryText }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="finalReportResponse">
        <th mat-header-cell *matHeaderCellDef>
          <strong *ngIf="hasResponse"> {{ "forms.common.Criteria.finalReportResponse" | translate }}</strong>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="content response" *ngIf="row?.finalReportResponseId && hasResponse">
            {{ "forms.common.Criteria.finalReportResponseAdded" | translate }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let row;let i = index" style="width: 50px">
          <div class="d-flex justify-content-end">

            <ng-container
              *ngIf="!decisionInput.viewOnly && decisionInput.executeVisitType == institutionEntries && isRecommendations && !row?.finalReportResponseId">
              <button mat-icon-button (click)="showResponse(decisionInput,row)"
                matTooltip="{{ 'forms.common.Criteria.AddResponse' | translate }}">
                <mat-icon>add</mat-icon>
              </button>
            </ng-container>
            <ng-container
              *ngIf="row?.finalReportResponseId && ((decisionInput.viewOnly && decisionInput.executeVisitType == institutionEntries) || hasResponse)">
              <button mat-icon-button (click)="showResponse(decisionInput,row)"
                matTooltip="{{ 'forms.common.Criteria.ShowResponse' | translate }}">
                <mat-icon>rate_review</mat-icon>
              </button>
            </ng-container>

            <ng-container *ngIf="row?.deleted;else showActions">
              <button mat-icon-button (click)="undo(i)" matTooltip="{{ 'forms.common.Criteria.Undo' | translate }}">
                <mat-icon>undo</mat-icon>
              </button>
            </ng-container>
            <ng-template #showActions>
              <button mat-icon-button (click)="showSummary(decisionInput,row,true)"
                matTooltip="{{ 'forms.common.Criteria.View' | translate }}">
                <mat-icon>visibility</mat-icon>
              </button>

              <ng-container *ngIf="enabledSummary">
                <button mat-icon-button (click)="showSummary(decisionInput,row)"
                  matTooltip="{{ 'forms.common.Criteria.Edit' | translate }}">
                  <mat-icon>edit_note</mat-icon>
                </button>

                <button mat-icon-button (click)="deleteSummary(i)"
                  matTooltip="{{ 'forms.common.Criteria.Delete' | translate }}">
                  <mat-icon color="warn">delete_forever</mat-icon>
                </button>
              </ng-container>
            </ng-template>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="noRecord">
        <td colspan="5" class="text-center" mat-footer-cell *matFooterCellDef>
          {{ "forms.common.No items added yet" | translate }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{'deleted': row?.deleted}"></tr>

      <tr [hidden]="!!dataSource?.length" mat-footer-row *matFooterRowDef="
          dataSource?.length === 0 ? ['noRecord'] : []
          "></tr>
    </table>
  </div>

  <div class="d-flex justify-content-end" *ngIf="enabledSummary">
    <button class="mt-3" mat-flat-button (click)="submit(decisionInput)" color="primary"
      [disabled]="!dataSource.length">
      {{ "forms.common.Criteria.save" | translate }}
    </button>
  </div>
</div>